import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_416: DocMigration = {
  maxSchemaVersion: "0.0.416",
  description: "Add new specific trim categories to ViewTemplates that have TRIM visible",
  apply(json: any) {
    if (!json.viewTemplates) {
      return json;
    }

    const newTrimCategories = [
      "ROOF_FRIEZE_BOARD",
      "ROOF_FASCIA_BOARD",
      "ROOF_SOFFIT",
      "ROOF_FASCIA_TOP_TRIM",
      "ROOF_BELLY_BAND_BOARD",
      "ROOF_WALL_BASE_BOARD",
      "ROOF_EXPOSED_RAFTER",
      "ROOF_GABLE_VENT",
      "CORNER_BOARD",
    ];

    // Iterate through all view templates
    for (const templateId in json.viewTemplates) {
      const template = json.viewTemplates[templateId];

      // Check if this template has TRIM visible
      if (template.categories && template.categories.includes("TRIM")) {
        // Add all new trim categories
        template.categories = [...template.categories, ...newTrimCategories];

        // Remove duplicates if any
        template.categories = [...new Set(template.categories)];
      }
    }

    return json;
  },
};

export default migration_0_0_416;
